import { useNavigate } from "react-router-dom";
import BreakPoints from "../../../BreakPoints";
import { useAskQuestion, useOpenField, useToggleField } from "../../../Store/MenuSlice";
import { useContext } from "react";
import { useIsVerified, UserContext } from "../../../context/UserContext";
import { useAuth } from "../../../context/AuthContext";
export default function AskState({ className, pos }) {
  const questionBoxState = useAskQuestion();
  const toggleField = useToggleField();
  const { medium, large, xLarge, xXLarge } = BreakPoints();
  const navigate = useNavigate();
  const isVerified = useIsVerified();
  const { isAuth } = useAuth();
  const openField = useOpenField();
  return (
    <button
      className={`pointer  ${!large && !medium ? "add-question" : ""}`}
      style={{
        transform: questionBoxState && (xLarge || xXLarge) ? "rotate(45deg)" : "none",
        transition: "0.6s",
      }}
      onClick={() => {
        if (!isAuth) {
          navigate("/login");
          return;
        }
        navigate("/query");
        toggleField("askQuestion");
      }}>
      {pos === "aside" ? "Have A question" : <i className="fa-solid fa-plus"></i>}
    </button>
  );
}
